<template>
  <div id="app">

    {{ debug("use mixin for debug: \{\{debug(MESSAGE)\}\} || this.debug(MESSAGE)") }}
    {{ debug(`isMobile: ${isMobile()}`)}}
    {{ debug(`smallScreen: ${this.smallScreen}`)}}

    <f-nav/>

    <router-view/>

    <f-footer/>

  </div>
</template>



<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
import navigation from '@/components/Globals/Navigation.vue'
import footerComponent from '@/components/Globals/Footer.vue'

export default {
	name: 'app',
	components: {
		'f-nav': navigation,
		'f-footer': footerComponent,
	},

}
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss">

$footer-height: 150px;
$footer-height-mobile: 170px;

#app {
	position: relative;
	min-height: 100%;
  padding-bottom: $footer-height;


	@include max-medium {
		padding-top: $header-height;
    padding-bottom: $footer-height-mobile;
	}
}
</style>
